import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * FilterTypesView class extends JetView to create a filter form.
 */
export default class FilterTypesView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Screen size configuration

        // Left section with ID input
        const left = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text', // Text input for ID
                    name: 'Id',
                    type: 'number', // Input type is number
                    label: _("<span class='icon-drivers-license-o'></span>ID"), // Localized label
                    labelPosition: 'top',
                    placeholder: _('ID'), // Placeholder text
                },
            ],
        };

        // Center-left section with Name input
        const center_left = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text', // Text input for Name
                    name: 'Name',
                    label: "<span class='icon-user'></span>" + _('Nombre'), // Localized label
                    labelPosition: 'top',
                    placeholder: _('Nombre'), // Placeholder text
                },
            ],
        };

        // Center-right section with Type selection
        const center_right = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'combo', // Combo box for Type selection
                    name: 'Type',
                    label: _('Tipo'), // Localized label
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '), // Placeholder text
                    options: [
                        // Options for the combo box
                        { id: 'null', value: _('Todos') },
                        { id: '0', value: _('Centro') },
                        { id: '1', value: _('Cargo') },
                    ],
                },
            ],
        };

        // Right section (currently empty)
        const right = {
            margin: 5,
            minWidth: 200,
            rows: [],
        };

        // Upper section containing the main input fields
        const upper_section = {
            id: 'a1',
            rows: [
                {
                    responsive: 'a1',
                    margin: 10,
                    cols: [left, center_left, center_right, right], // Layout of columns
                },
            ],
        };

        // Button section with action buttons
        const buttons = {
            margin: 5,
            cols: [
                {},
                {
                    view: 'button', // Button to add a new type
                    value: _('Añadir Tipo'), // Localized button text
                    type: 'form',
                    autowidth: true,
                    hidden: !devConfig.getPermAction(
                        // Conditional visibility based on permissions
                        'accountingTypeCenterPositionAdd',
                        'Add',
                    ),
                    css: 'prm-accountingTypeCenterPositionAdd', // CSS class for styling
                    click: () => {
                        // Click event handler
                        this.app.callEvent('addType:button', [{}]); // Trigger add type event
                    },
                },
                {
                    view: 'button', // Button to clear the form
                    value: _('Limpiar'), // Localized button text
                    autowidth: true,
                    click: () => {
                        this.getRoot().clear(); // Clear form values
                    },
                },
                {
                    view: 'button', // Button to consult/filter types
                    value: _('Consultar'), // Localized button text
                    hotkey: 'enter', // Hotkey for the button
                    type: 'form',
                    autowidth: true,
                    click: () => {
                        const filterdata = this.getRoot().getValues(); // Get form values
                        this.app.callEvent('type:filter', [filterdata]); // Trigger filter event
                    },
                },
            ],
        };

        // Return the complete form configuration
        return {
            view: 'form', // Main view type
            rows: [upper_section, buttons], // Combine upper section and buttons
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for form fields
            },
        };
    }
}

// FILE DOCUMENTED
